import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';

export interface FilterSelectOption {
  label: string;
  value: string;
}

export interface FilterSelectProps {
  placeholder: string;
  options: FilterSelectOption[];
  value: string | null;
  onChange: (value: string | null) => void;
  disabled?: boolean;
  valueLabel?: string;
}

export function FilterSelect({
  placeholder,
  options,
  value,
  onChange,
  disabled,
  valueLabel,
}: FilterSelectProps) {
  const hasValue = valueLabel !== undefined || value !== null;
  const selectedLabel =
    valueLabel ??
    (value
      ? options.find((option) => option.value === value)?.label ?? value
      : placeholder);

  return (
    <Listbox
      value={value ?? ''}
      onChange={(next) => onChange(next === '' ? null : next)}
      disabled={disabled}
    >
      <div className='relative font-inter'>
        <ListboxButton className='flex h-9 w-full items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200 disabled:cursor-not-allowed disabled:bg-gray-50'>
          <span
            className={`flex-1 truncate text-left ${
              hasValue ? 'text-gray-900' : 'text-gray-500'
            }`}
          >
            {selectedLabel}
          </span>
          <ChevronDownIcon className='h-4 w-4 shrink-0 text-gray-400' />
        </ListboxButton>
        <ListboxOptions
          anchor='bottom start'
          modal={false}
          className='z-[1200] mt-1 max-h-60 w-[var(--button-width)] overflow-auto rounded-lg border border-gray-200 bg-white py-1 text-sm shadow-lg focus:outline-none'
        >
          <ListboxOption
            value=''
            className='cursor-pointer px-3 py-2 text-gray-700 data-[focus]:bg-blue-50 data-[focus]:text-primary data-[selected]:font-medium'
          >
            <span className='block truncate'>{placeholder}</span>
          </ListboxOption>
          {options.map((option) => (
            <ListboxOption
              key={option.value}
              value={option.value}
              className='cursor-pointer px-3 py-2 text-gray-700 data-[focus]:bg-blue-50 data-[focus]:text-primary data-[selected]:font-medium'
            >
              <span className='block truncate'>{option.label}</span>
            </ListboxOption>
          ))}
        </ListboxOptions>
      </div>
    </Listbox>
  );
}
